import axios from 'axios'

const DashboardService = {
  async getStatistics (params = {}) {
    return axios.get('wo/dashboard', { params })
  }
}

export default DashboardService
